import {
  Autocomplete,
  createFilterOptions,
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { useHistory, useParams } from "react-router";
import { useEffect } from "react";
import api from "../../../../components/services/api";
import moment from "moment";
import Swal from "sweetalert2";

// ตัว filter สำหรับ Autocomplete ช่อง Attendee (ชุดเดียวกับ AdvancePayment) —
// ทำให้ "พิมพ์เพื่อกรอง" ทำงาน + เสนอเพิ่มค่าที่พิมพ์เองได้
const attendeeFilter = createFilterOptions();

export default function Repairdetail() {
  const history = useHistory()
  const { id } = useParams()
  const [rows, setRows] = useState([]);
  const [masterCost, setMasterCost] = useState([]);
  const [data, setData] = useState(null)
  const [status, setStatus] = useState('')
  const [vat, setVat] = useState('')
  const [billTo, setBillTo] = useState([]);
  const [currency, setCurrency] = useState([]);

  // คำนวณยอดของแถวใหม่ทั้งหมดจาก Quantity / PricePerUnit / Tax / Withholding / ExchangeRate
  // สูตรตรงกับ SaleOrderExtraExpense / SaleOrderAdvancePayment เพื่อให้ข้อมูลไหลไปต่อได้ถูกต้อง
  const recalcRow = (row) => {
    const amount = +row.Quantity * +row.PricePerUnit;
    const taxAmount = amount * (+(row.TaxPercent || 0) / 100);
    const withholdingTax = amount * (+(row.WithholdingTaxPercent || 0) / 100);
    const totalAmount = amount + (taxAmount - withholdingTax);
    const rate = +row.ExchangeRate || 0;

    return {
      ...row,
      Amount: amount,
      TaxAmount: taxAmount,
      WithholdingTaxAmount: withholdingTax,
      TotalAmount: totalAmount,
      AmountTHB: amount * rate,
      TaxAmountTHB: taxAmount * rate,
      WithholdingTaxAmountTHB: withholdingTax * rate,
      TotalAmountTHB: totalAmount * rate,
      Total: amount,
    };
  };

  const updateFieldAndTotals = (rows, data, fieldName, value) => {
    const body = rows.map((v) => {
      if (v.id !== data.id) return v;

      const updatedRow = { ...v, [fieldName]: value };

      // เปลี่ยนสกุลเงิน: เก็บ CurrencyCode ตามด้วย และถ้าเป็น THB ให้ล็อกอัตราแลกเปลี่ยน = 1
      if (fieldName === "CurrencyId") {
        const cur = currency?.find((x) => x?.CurrencyId === value);
        updatedRow.CurrencyCode = cur?.CurrencyCode || "";
        if (cur?.CurrencyCode === "THB") {
          updatedRow.ExchangeRate = 1;
        }
      }

      return recalcRow(updatedRow);
    });
    setRows(body);
  };

  // เลือก/พิมพ์ Description: ถ้าตรงกับ master cost ให้เติมราคาต่อหน่วยอัตโนมัติ แล้วคำนวณยอดใหม่
  const handleChargeChange = (rows, data, newValue, fillPrice) => {
    const matched = masterCost.find((x) => x?.CostName === newValue);
    const body = rows.map((v) => {
      if (v.id !== data.id) return v;

      const updatedRow = { ...v, Charge: newValue };
      if (fillPrice && matched) {
        updatedRow.PricePerUnit = matched.CostPrice;
      }
      return recalcRow(updatedRow);
    });
    setRows(body);
  };

  function addRow() {
    const newRow = {
      id: rows?.slice(-1)[0]?.id ? rows?.slice(-1)[0]?.id + 1 : 1,
      Charge: "",
      TaxPercent: 0,
      WithholdingTaxPercent: 0,
      Quantity: 0,
      PricePerUnit: 0,
      CurrencyId: "",
      CurrencyCode: "",
      ExchangeRate: 1,
      Amount: 0,
      TaxAmount: 0,
      WithholdingTaxAmount: 0,
      TotalAmount: 0,
      AmountTHB: 0,
      TaxAmountTHB: 0,
      WithholdingTaxAmountTHB: 0,
      TotalAmountTHB: 0,
      Total: 0,
      Attend: '',
      Attendee: '',
    };

    setRows([...rows, newRow]);
  }
  const deletehand = (i) => {
    const data = rows?.filter((e) => i !== e?.id);
    setRows(data);
  };


  const getDetail = async () => {
    const res = await api.get(`api/repair/detail/information/${id}`)
    const data = await res.data
    if (res.meta.status === true) {
      setData(data)
      setStatus(data.RepairStatus)
      const io = data.Detail?.map((x, i) => {
        return recalcRow({
          ...x,
          id: i + 1,
          ExchangeRate: x.ExchangeRate || 1,
        });
      });

      setRows([...io]);
    }
  }

  const getVat = async () => {
    const res = await api.get(`api/master/Vatvalue`)
    const data = await res.data.data
    if (res.meta.status === true) {
      setVat(data)
    }
  }
  const getMasterCost = async () => {
    try {
      const res = await api.get(`/api/master/cost/Repair%20Cost`);
      setMasterCost(res?.data);

      //   setLog_data_length(3);
    } catch (e) {
      console.log(e);
    }
  };
  const getBiller = async () => {
    try {
      const res = await api.get(`api/master/biller-payer`);
      setBillTo(res?.data?.data);

      //   setLog_data_length(3);
    } catch (e) {
      console.log(e);
    }
  };
  const getCurrency = async () => {
    try {
      const res = await api.get(`api/master/currency`);
      setCurrency(res?.data);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getDetail()
    getVat()
    getMasterCost()
    getBiller()
    getCurrency()
  }, []);

  const postData = async () => {
    const body = {
      RepairContainerId: id,
      RepairStatus: status,
      Detail: rows
    }
    const res = await api.post(`api/repair/update/information`, body)
    if (res.meta.status === true) {
      Swal.fire(
        'อัพเดทสำเร็จ',
        'ส่งข้อมูลสำเร็จ',
        'success'
      )
    }
  }

  const sumTHB = (field) =>
    rows?.length > 1
      ? rows?.map((s) => s?.[field] || 0)?.reduce((a, b) => a + b)
      : rows?.length === 1
        ? rows[0]?.[field] || 0
        : 0;

  return (
    <>
      <Box>
        <Box sx={{ display: "flex", alignItems: "end" }}>
          <Typography
            sx={{ fontWeight: "700", fontSize: "25px", color: "#30318d" }}
          >
            Repair Status
          </Typography>
          <FormControl size="small" sx={{ width: '200px', marginLeft: '10px' }}>
            <InputLabel>Status</InputLabel>
            <Select
              label="Status"
              value={status}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {
                setStatus(e.target.value)
              }}
            >
              <MenuItem value='New'>New</MenuItem>
              <MenuItem value='Processing'>Processing</MenuItem>
              <MenuItem value='Done'>Done</MenuItem>
              <MenuItem value='Declined'>Declined</MenuItem>
            </Select>
          </FormControl>

        </Box>

        <Box sx={{ display: "flex", marginTop: "50px" }}>
          <Grid
            container
            spacing={2}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <Grid item xs={4}>
              <TextField label="Container No" value={data?.ContainerNo || ''} sx={{ width: "100%" }} />
            </Grid>

            <Grid item xs={4}>
              <TextField label="Customer Name" value={data?.SaleOrder?.Customer?.CustomerName || ''} sx={{ width: "100%" }} />
            </Grid>
            <Grid item xs={4}></Grid>

            <Grid item xs={4}>
              <TextField label="Shipper Ref No" value={data?.SaleOrder?.ShipperRefNo || ''} sx={{ width: "100%" }} />
            </Grid>
            <Grid item xs={4}>
              <TextField label="Booking No" value={data?.SaleOrder?.BookingNo || ''} sx={{ width: "100%" }} />
            </Grid>
            <Grid item xs={4}></Grid>
          </Grid>
        </Box>
        <Box sx={{ display: "flex", marginTop: "45px" }}>
          {" "}
          <Typography
            sx={{ fontWeight: "700", fontSize: "20px", color: "#30318d" }}
          >
            VOLUME
          </Typography>
        </Box>
        <Box sx={{ display: "flex", marginTop: "50px" }}>
          <Grid
            container
            spacing={2}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <Grid item xs={4}>
              <TextField label="Size" value={data?.SaleOrder?.ContainerType?.Size || ''} sx={{ width: "100%" }} />
            </Grid>

            <Grid item xs={4}>
              <TextField label="Quantity" value={data?.SaleOrder?.Quantity || ''} sx={{ width: "100%" }} />
            </Grid>
            <Grid item xs={4}></Grid>
            <Grid item xs={2}>
              <TextField label="Container Status" value={data?.SaleOrder?.ContainerStockType || ''} sx={{ width: "100%" }} />
            </Grid>
            <Grid item xs={2}>
              <TextField label="Grade" value={data?.SaleOrder?.ContainerGrade || ''} sx={{ width: "100%" }} />
            </Grid>
            <Grid item xs={2}>
              <TextField label="Agent Line" value={data?.SaleOrder?.Liners?.LinersName || ''} sx={{ width: "100%" }} />
            </Grid>
            <Grid item xs={2}>
              <TextField label="Plastic Sheet" value={data?.SaleOrder?.ContainerApplyPlasticSheet === true ? "Yes" : "No" || ''} sx={{ width: "100%" }} />
            </Grid>
            <Grid item xs={2}>
              <TextField label="Container Gender" value={data?.SaleOrder?.InboundContainerGender || ''} sx={{ width: "100%" }} />
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ display: "flex", marginTop: "50px" }}>
          <Grid
            container
            spacing={2}
            columns={14}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <Grid item xs={7}>
              <Typography
                sx={{ fontWeight: "700", fontSize: "20px", color: "#30318d" }}
              >
                {data?.SaleOrder?.InboundContainerGender || 'Empty'} Container
              </Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography
                sx={{ fontWeight: "700", fontSize: "20px", color: "#30318d" }}
              >
                {data?.SaleOrder?.InboundContainerGender === 'Laden' ? 'Empty' : 'Laden'} Container
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <TextField label="VOY IN" value={data?.SaleOrder?.InboundVoyNo || ''} sx={{ width: "100%" }} />
            </Grid>
            <Grid item xs={2}>
              <TextField label="ETD Gate Out" value={data?.SaleOrder?.InboundETDGateOut ? moment(data?.SaleOrder?.InboundETDGateOut).format('yyyy-MM-DD') : '' || ''} sx={{ width: "100%" }} />
            </Grid>
            <Grid item xs={2}>
              <TextField label="ETA Gate IN" value={data?.SaleOrder?.InboundETAGateIn ? moment(data?.SaleOrder?.InboundETAGateIn).format('yyyy-MM-DD') : '' || ''} sx={{ width: "100%" }} />
            </Grid>
            <Grid item xs={1}>
              <TextField label="Quantity" value={data?.SaleOrder?.InboundQuantity || ''} sx={{ width: "100%" }} />
            </Grid>
            <Grid item xs={2}>
              <TextField label="VOY OUT" value={data?.SaleOrder?.OutboundVoyNo || ''} sx={{ width: "100%" }} />
            </Grid>
            <Grid item xs={2}>
              <TextField label="ETD Gate Out" value={data?.SaleOrder?.OutboundETDGateOut ? moment(data?.SaleOrder?.OutboundETDGateOut).format('yyyy-MM-DD') : '' || ''} sx={{ width: "100%" }} />
            </Grid>
            <Grid item xs={2}>
              <TextField label="ETA Gate IN" value={data?.SaleOrder?.OutboundETAGateIn ? moment(data?.SaleOrder?.OutboundETAGateIn).format('yyyy-MM-DD') : '' || ''} sx={{ width: "100%" }} />
            </Grid>
            <Grid item xs={1}>
              <TextField label="Quantity" value={data?.SaleOrder?.OutboundQuantity || ''} sx={{ width: "100%" }} />
            </Grid>
            {data?.SaleOrder?.InboundTransportGroupId === 'G002' || data?.SaleOrder?.OutboundTransportGroupId === 'G002' ? <>
              <Grid item xs={2}>
                <TextField label="VOY IN" value={data?.SaleOrder?.InboundVoyNo_2 || ''} sx={{ width: "100%" }} />
              </Grid>
              <Grid item xs={2}>
                <TextField label="ETD Gate Out" value={data?.SaleOrder?.InboundETDGateOut_2 ? moment(data?.SaleOrder?.InboundETDGateOut_2).format('yyyy-MM-DD') : '' || ''} sx={{ width: "100%" }} />
              </Grid>
              <Grid item xs={2}>
                <TextField label="ETA Gate IN" value={data?.SaleOrder?.InboundETAGateIn_2 ? moment(data?.SaleOrder?.InboundETAGateIn_2).format('yyyy-MM-DD') : '' || ''} sx={{ width: "100%" }} />
              </Grid>
              <Grid item xs={1}>
                <TextField label="Quantity" value={data?.SaleOrder?.InboundQuantity_2 || ''} sx={{ width: "100%" }} />
              </Grid>
              <Grid item xs={2}>

                <TextField label="VOY OUT" value={data?.SaleOrder?.OutboundVoyNo_2 || ''} sx={{ width: "100%" }} />
              </Grid>
              <Grid item xs={2}>
                <TextField label="ETD Gate Out" value={data?.SaleOrder?.OutboundETDGateOut_2 ? moment(data?.SaleOrder?.OutboundETDGateOut_2).format('yyyy-MM-DD') : '' || ''} sx={{ width: "100%" }} />
              </Grid>
              <Grid item xs={2}>
                <TextField label="ETA Gate IN" value={data?.SaleOrder?.OutboundETAGateIn_2 ? moment(data?.SaleOrder?.OutboundETAGateIn_2).format('yyyy-MM-DD') : '' || ''} sx={{ width: "100%" }} />
              </Grid>
              <Grid item xs={1}>
                <TextField label="Quantity" value={data?.SaleOrder?.OutboundQuantity_2 || ''} sx={{ width: "100%" }} />
              </Grid>
              <Grid item xs={2}>
                <TextField label="VOY IN" value={data?.SaleOrder?.InboundVoyNo3 || ''} sx={{ width: "100%" }} />
              </Grid>
              <Grid item xs={2}>
                <TextField label="ETD Gate Out" value={data?.SaleOrder?.InboundETDGateOut_3 ? moment(data?.SaleOrder?.InboundETDGateOut_3).format('yyyy-MM-DD') : '' || ''} sx={{ width: "100%" }} />
              </Grid>
              <Grid item xs={2}>
                <TextField label="ETA Gate IN" value={data?.SaleOrder?.InboundETAGateIn_3 ? moment(data?.SaleOrder?.InboundETAGateIn_3).format('yyyy-MM-DD') : '' || ''} sx={{ width: "100%" }} />
              </Grid>
              <Grid item xs={1}>
                <TextField label="Quantity" value={data?.SaleOrder?.InboundQuantity_3 || ''} sx={{ width: "100%" }} />
              </Grid>
              <Grid item xs={2}>
                <TextField label="VOY OUT" value={data?.SaleOrder?.OutboundVoyNo_3 || ''} sx={{ width: "100%" }} />
              </Grid>
              <Grid item xs={2}>
                <TextField label="ETD Gate Out" value={data?.SaleOrder?.OutboundETDGateOut_3 ? moment(data?.SaleOrder?.OutboundETDGateOut_3).format('yyyy-MM-DD') : '' || ''} sx={{ width: "100%" }} />
              </Grid>
              <Grid item xs={2}>
                <TextField label="ETA Gate IN" value={data?.SaleOrder?.OutboundETAGateIn_3 ? moment(data?.SaleOrder?.OutboundETAGateIn_3).format('yyyy-MM-DD') : '' || ''} sx={{ width: "100%" }} />
              </Grid>
              <Grid item xs={1}>
                <TextField label="Quantity" value={data?.SaleOrder?.OutboundQuantity_3 || ''} sx={{ width: "100%" }} />
              </Grid>
            </> : ''}
          </Grid>
        </Box>
        <Box sx={{ display: "flex", marginTop: "45px" }}>
          {" "}
          <Typography
            sx={{ fontWeight: "700", fontSize: "20px", color: "#30318d" }}
          >
            STUFFING PLAN
          </Typography>
        </Box>
        <Box sx={{ marginTop: "10px" }}>
          <TableContainer>
            <Table>
              <TableHead sx={{ backgroundColor: "#e7e7e7" }}>
                <TableRow>
                  <TableCell sx={{ width: "20%" }}>Pick-up Date</TableCell>
                  <TableCell sx={{ width: "40%" }}>Factory</TableCell>
                  <TableCell sx={{ width: "20%" }}>Return Date</TableCell>
                  <TableCell sx={{ width: "20%" }}>Gate Out</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.SaleOrder?.StuffingPlan?.map((x, i) => (
                  <TableRow key={i}>
                    <TableCell>{x?.PickupDate}</TableCell>
                    <TableCell>{x?.Factory?.FactoryName}</TableCell>
                    <TableCell>{x?.ReturnDate}</TableCell>
                    <TableCell>{data?.SaleOrder?.OutboundGateOut?.LocationName}</TableCell>
                  </TableRow>
                ))}

              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Box>
          <Button
            type="button"
            variant="contained"
            style={{
              background: "#80c340",
              borderColor: "#80c340",
              marginTop: "35px",
            }}
            onClick={addRow}
          >
            <AddIcon /> Add
          </Button>
        </Box>
        <Box>
          <div style={{ overflowX: "auto" }}>
            <TableContainer sx={{ marginTop: 2, marginBottom: 2, width: "260%" }}>
              <Table stickyHeader>
                <TableRow>
                  <TableCell align="center" width="60px">#</TableCell>
                  <TableCell align="center" width="200px">Description</TableCell>
                  <TableCell align="center" width="100px">Tax%</TableCell>
                  <TableCell align="center" width="130px">Withholding Tax%</TableCell>
                  <TableCell align="center" width="100px">Quantity</TableCell>
                  <TableCell align="center" width="110px">Price / Unit</TableCell>
                  <TableCell align="center" width="110px">Currency</TableCell>
                  <TableCell align="center" width="110px">Exchang Rate</TableCell>
                  <TableCell align="center" width="110px">Amount</TableCell>
                  <TableCell align="center" width="110px">Tax Amount</TableCell>
                  <TableCell align="center" width="120px">Withholding Tax</TableCell>
                  <TableCell align="center" width="110px">Total Amount</TableCell>
                  <TableCell align="center" width="120px">Amount (THB)</TableCell>
                  <TableCell align="center" width="130px">Tax Amount (THB)</TableCell>
                  <TableCell align="center" width="140px">Withholding Tax (THB)</TableCell>
                  <TableCell align="center" width="130px">Total Amount (THB)</TableCell>
                  <TableCell align="center" width="160px">Attend</TableCell>
                  <TableCell align="center" width="180px">Attendee</TableCell>
                  <TableCell align="center" width="100px"></TableCell>
                </TableRow>
                {rows?.map((data, i) => {
                  return (
                    <TableBody key={i}>
                      <TableCell align="center">{i + 1}</TableCell>
                      <TableCell align="center">
                        <Autocomplete
                          freeSolo
                          options={masterCost.map((option) => option.CostName)}
                          renderInput={(params) => <TextField {...params} label="Description" />}
                          value={data?.Charge}
                          onChange={(event, newValue) => {
                            handleChargeChange(rows, data, newValue, true);
                          }}
                          disableClearable
                          inputValue={data?.Charge || ""}
                          onInputChange={(event, newInputValue) => {
                            handleChargeChange(rows, data, newInputValue, false);
                          }}
                        />
                      </TableCell>

                      <TableCell align="center">
                        <FormControl fullWidth>
                          <InputLabel>Tax</InputLabel>
                          <Select
                            label="Tax"
                            value={data?.TaxPercent}
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => {
                              updateFieldAndTotals(rows, data, "TaxPercent", e.target.value);
                            }}
                          >
                            {vat?.map((x) => (
                              <MenuItem value={parseInt(x?.VatvalueNumber)}>{x?.VatvalueNumber}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </TableCell>
                      <TableCell align="center">
                        <FormControl fullWidth>
                          <InputLabel>Withholding Tax</InputLabel>
                          <Select
                            label="Withholding Tax"
                            value={data?.WithholdingTaxPercent || ""}
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => {
                              updateFieldAndTotals(rows, data, "WithholdingTaxPercent", e.target.value);
                            }}
                          >
                            {vat?.map((x) => (
                              <MenuItem value={parseInt(x?.VatvalueNumber)}>{x?.VatvalueNumber}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </TableCell>
                      <TableCell align="center">
                        <TextField
                          label="Quantity"
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          value={data?.Quantity}
                          onChange={(e) => {
                            updateFieldAndTotals(rows, data, "Quantity", +e.target.value);
                          }}
                        />
                      </TableCell>

                      <TableCell align="center">
                        <TextField
                          label="Price/Unit"
                          value={data?.PricePerUnit}
                          type='number'
                          sx={{
                            '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button':
                            {
                              display: 'none',
                            },
                            '& input[type=number]': {
                              MozAppearance: 'textfield',
                            },
                          }}
                          onChange={(e) => {
                            updateFieldAndTotals(rows, data, "PricePerUnit", parseFloat(e.target.value) || 0);
                          }}
                        />
                      </TableCell>

                      <TableCell align="center">
                        <FormControl fullWidth>
                          <InputLabel>Currency</InputLabel>
                          <Select
                            label="Currency"
                            value={data?.CurrencyId || ""}
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => {
                              updateFieldAndTotals(rows, data, "CurrencyId", e.target.value);
                            }}
                          >
                            {currency?.map((x) => (
                              <MenuItem value={x?.CurrencyId}>{x?.CurrencyCode}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </TableCell>
                      <TableCell align="center">
                        <TextField
                          label="Exchang Rate"
                          value={data?.ExchangeRate || ""}
                          onChange={(e) => {
                            updateFieldAndTotals(rows, data, "ExchangeRate", e.target.value);
                          }}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <TextField label="Amount" value={(+data?.Amount || 0).toFixed(2)} />
                      </TableCell>
                      <TableCell align="center">
                        <TextField label="Tax Amount" value={(+data?.TaxAmount || 0).toFixed(2)} />
                      </TableCell>
                      <TableCell align="center">
                        <TextField label="Withholding Tax" value={(+data?.WithholdingTaxAmount || 0).toFixed(2)} />
                      </TableCell>
                      <TableCell align="center">
                        <TextField label="Total Amount" value={(+data?.TotalAmount || 0).toFixed(2)} />
                      </TableCell>
                      <TableCell align="center">
                        <TextField label="Amount (THB)" value={(+data?.AmountTHB || 0).toFixed(2)} />
                      </TableCell>
                      <TableCell align="center">
                        <TextField label="Tax Amount (THB)" value={(+data?.TaxAmountTHB || 0).toFixed(2)} />
                      </TableCell>
                      <TableCell align="center">
                        <TextField label="Withholding Tax (THB)" value={(+data?.WithholdingTaxAmountTHB || 0).toFixed(2)} />
                      </TableCell>
                      <TableCell align="center">
                        <TextField label="Total Amount (THB)" value={(+data?.TotalAmountTHB || 0).toFixed(2)} />
                      </TableCell>
                      <TableCell align="center">
                        <FormControl fullWidth>
                          <InputLabel>Attend</InputLabel>
                          <Select
                            label="Attend"
                            value={data?.Attend}
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => {
                              const io = rows?.map((v) => {
                                v.Attend = v?.id === data?.id ? e.target.value : v?.Attend;

                                return v;
                              });

                              setRows([...io]);
                            }}
                          >
                            <MenuItem value='Bill to Customer'>Bill to Customer</MenuItem>
                            <MenuItem value='Cost'>Cost</MenuItem>
                          </Select>
                        </FormControl>
                      </TableCell>
                      <TableCell align="center">
                        {/* Attendee = ผู้ที่เกี่ยวข้อง (Bill to Customer = ผู้ถูกวางบิล, Cost = ผู้รับจ่าย)
                            ใช้ master biller-payer เดียวกันทั้งสองกรณี (ตรงกับ AdvancePayment/ExtraExpense)
                            ซึ่งเป็น union ครบทุกประเภท (Company/Customer/Factory/Vender/Depots ฯลฯ).
                            selectOnFocus/clearOnBlur + filterOptions ยกจาก AdvancePayment เพื่อให้
                            "พิมพ์เพื่อกรอง" ทำงานถูก (ไม่งั้น MUI โชว์ทุก option เมื่อ input == ค่าที่เลือก) */}
                        <Autocomplete
                          freeSolo
                          selectOnFocus
                          clearOnBlur
                          handleHomeEndKeys
                          disableClearable
                          options={billTo.map((option) => option.Name)}
                          value={data?.Attendee || null}
                          filterOptions={(options, params) => {
                            const filtered = attendeeFilter(options, params);
                            const { inputValue } = params;
                            const isExisting = options.some((o) => inputValue === o);
                            if (inputValue !== "" && !isExisting) {
                              filtered.push({ inputValue, label: `เพิ่ม "${inputValue}"` });
                            }
                            return filtered;
                          }}
                          getOptionLabel={(option) =>
                            typeof option === "string" ? option : option?.inputValue || ""
                          }
                          renderOption={(props, option) => (
                            <li {...props}>
                              {typeof option === "string" ? option : option?.label}
                            </li>
                          )}
                          renderInput={(params) => <TextField {...params} label="Attendee" />}
                          onChange={(event, newValue) => {
                            const picked =
                              typeof newValue === "string"
                                ? newValue
                                : newValue?.inputValue || "";
                            const io = rows?.map((v) => {
                              if (v?.id === data?.id) v.Attendee = picked;
                              return v;
                            });
                            setRows([...io]);
                          }}
                        />
                      </TableCell>

                      <TableCell align="center">
                        <Button
                          type="button"
                          variant="outlined"
                          style={{
                            color: "#80c340",
                            borderColor: "#80c340",
                          }}
                          onClick={() => deletehand(data?.id)}
                        >
                          Delete
                        </Button>
                      </TableCell>
                    </TableBody>
                  );
                })}
              </Table>
            </TableContainer>
          </div>
          <Table sx={{ marginBottom: "15px" }}>
            <TableRow>
              <TableCell align="center" width="40%"></TableCell>
              <TableCell align="center" width="20%"></TableCell>
              <TableCell align="center" width="30%"></TableCell>
              <TableCell align="center" width="10%"></TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={1} rowSpan={4} />
              <TableCell colSpan={1}>Total Amount (Excluding Tax)</TableCell>
              <TableCell colSpan={1} sx={{ textAlign: "end" }}>
                {parseFloat(sumTHB("AmountTHB")).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}
              </TableCell>
              <TableCell colSpan={1}>THB</TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={1}>Withholding Tax</TableCell>
              <TableCell colSpan={1} sx={{ textAlign: "end" }}>
                {parseFloat(sumTHB("WithholdingTaxAmountTHB")).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}
              </TableCell>
              <TableCell colSpan={1}>THB</TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={1}>TotalTax</TableCell>
              <TableCell colSpan={1} sx={{ textAlign: "end" }}>
                {parseFloat(sumTHB("TaxAmountTHB")).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}
              </TableCell>
              <TableCell colSpan={1}>THB</TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={1}>TotalAmount</TableCell>
              <TableCell colSpan={1} sx={{ textAlign: "end" }}>
                {parseFloat(sumTHB("TotalAmountTHB")).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}
              </TableCell>
              <TableCell colSpan={1}>THB</TableCell>
            </TableRow>
          </Table>
        </Box>
        <Box sx={{ display: "flex", marginTop: "25px" }}>
          <Button
            sx={{ width: 80 }}
            type="button"
            variant="outlined"
            style={{
              color: "#80c340",
              borderColor: "#80c340",
              marginRight: "10px",
            }}
            onClick={history.goBack}
          >
            close
          </Button>
          <Button
            sx={{ width: 80 }}

            variant="contained"
            style={{
              background: "#80c340",
              borderColor: "#80c340",
              marginRight: "10px",
            }}
            onClick={postData}
          >
            Save
          </Button>
        </Box>
      </Box>
    </>
  );
}
